import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/error.svg
 */
const IconError: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.333 21.978A12 12 0 0012 24a12.034 12.034 0 0012-11.998 12 12 0 10-18.667 9.976zm.824-18.72A10.517 10.517 0 0112 1.485a10.547 10.547 0 0110.517 10.517 10.517 10.517 0 11-16.36-8.744zm.677 13.908a1.333 1.333 0 010-1.886l3.28-3.28-3.28-3.28a1.333 1.333 0 111.885-1.886l3.28 3.28 3.282-3.28a1.333 1.333 0 111.885 1.885L13.886 12l3.28 3.28a1.333 1.333 0 01-1.886 1.886L12 13.886l-3.28 3.28c-.521.52-1.366.52-1.886 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconError;
